import {
    ICategoricalGroup2GoodsUnionDTO,
    ICategoricalGroup2GoodsUnionViewDTO,
    ICategoricalGroupLinkUnionDTO,
    ICategoricalGroupLinkUnionViewDTO,
    ICategoricalGroupUnionDTO,
    ICategoricalGroupUnionViewDTO
} from "../../coreapi-dto/dirs/categoricalGroup";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";

class CategoricalGroupUnionRequest extends BaseDirRequest<ICategoricalGroupUnionViewDTO, ICategoricalGroupUnionDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "CategoricalGroupUnion", token, eventHandler)
    }

    getViewParam(body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<ICategoricalGroupUnionViewDTO>>) => void, signal?: AbortSignal | null) {
        this.post<IViewWrapper<ICategoricalGroupUnionViewDTO>>(`${this._baseUrl}/${this._routePrefix}/View`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                } else {
                    callback?.(e);
                }
            }
        }, signal)
    }
}

class CategoricalGroup2GoodsUnionRequest extends BaseDirRequest<ICategoricalGroup2GoodsUnionViewDTO, ICategoricalGroup2GoodsUnionDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "CategoricalGroup2GoodsUnion", token, eventHandler)
    }

    getViewParam(body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<ICategoricalGroup2GoodsUnionViewDTO>>) => void, signal?: AbortSignal | null) {
        this.post<IViewWrapper<ICategoricalGroup2GoodsUnionViewDTO>>(`${this._baseUrl}/${this._routePrefix}/View`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                } else {
                    callback?.(e);
                }
            }
        }, signal)
    }
}

class CategoricalGroupLinkUnionRequest extends BaseDirRequest<ICategoricalGroupLinkUnionViewDTO, ICategoricalGroupLinkUnionDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "CategoricalGroupLinkUnion", token, eventHandler)
    }

    getViewParam(body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<ICategoricalGroupLinkUnionViewDTO>>) => void, signal?: AbortSignal | null) {
        this.post<IViewWrapper<ICategoricalGroupLinkUnionViewDTO>>(`${this._baseUrl}/${this._routePrefix}/View`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                } else {
                    callback?.(e);
                }
            }
        }, signal)
    }
}

export { CategoricalGroupUnionRequest, CategoricalGroup2GoodsUnionRequest, CategoricalGroupLinkUnionRequest }